// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8756ccb5","44":"87f0707f","107":"edf8e90c","184":"2dc4aaa3","186":"8132d5f6","355":"a05e750a","426":"2a48d515","453":"cfd59cba","518":"8cc3af7d","548":"c46396bc","570":"c949d811","641":"310188ad","691":"fa1d0dca","916":"9079a8bb","977":"18f4806c","998":"cff76668"}[chunkId] + ".chunk.js";
};